import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { CoachCompany } from '../../../lib/types/models/ol/coach-company/coach-company'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCoachCompanies(input: PaginationRequest & { olId: number }) {
  const { olId, ...rest } = input
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.ols.getCoachCompanies.url, { olId }),
        rest
      )
    )
    .get<PaginationResponse<CoachCompany>>()
}
